import { TypedDispatch, TypedThunk } from "App/Store";
import { BRACKET_DETAILS_ACTION } from "core/constants/Actions";
import { getBracketDetails } from "core/services/Bracket";

export function bracketDetails(tournamentId: string | number): TypedThunk {
  return async (dispatch: TypedDispatch): Promise<void> => {
    dispatch({ type: BRACKET_DETAILS_ACTION.REQUEST });
    const apiResponse = await getBracketDetails(tournamentId);
    if (apiResponse.status && apiResponse.data) {
      dispatch({
        type: BRACKET_DETAILS_ACTION.SUCCESS,
        payload: {
          brackets: apiResponse.data.brackets,
          tournament: apiResponse.data.tournament,
        },
      });
    } else {
      dispatch({
        type: BRACKET_DETAILS_ACTION.FAILURE,
      });
    }
  };
}
